import React, { useCallback, useState, useEffect, useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector } from 'react-redux'
import { action_cart_checkout_get, action_fetch_coupons, action_fetch_addresses, action_fetch_card_list } from '../../../../../store/actions/pages/cart'
import { TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from '../../../../../store/actions/ui'
import NormalPage from '../../layout/normal-page'
import { NBoxes, Box } from '../../layout/box'
import { Redirect, useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import AddressSelector from './fragments/address-selector'
import BaseBox, { EmptyTitle } from './layout/base-box'
import Groups from './fragments/groups'
import PaymentMethods from './fragments/payment-methods'
import WalletTool from './fragments/wallet-tool'
import CouponTool from './fragments/coupon-tool'
import PointsTool from './fragments/points-tool'
import OrderSummary from './fragments/order-summary'
import useCheckout from './hooks/checkout'
import Loading from '../../../../components/loading/op-loading'
import PlaceorderFooter from './fragments/placeorder-footer'
import CouponSelector from '../../fragments/coupon'
import { useStore } from 'react-redux'
import { useDispatch } from 'react-redux'
import AddressBook from '../../fragments/address/address-book-normal'
import AddressEditor from '../../fragments/address/address-editor'
import { useLogin, useQuery } from '../../../../hooks/common'
import { useRef } from 'react'
import LoadingPage from './fragments/loading-page'
import {getSensorsUrl, SensorsTrack} from '../../../../utils/sensor'
import Cache from '../../../../../utils/cache'
import CouponTip from './fragments/coupon-tip'
import * as Paymethods from '../../../../../utils/paymethods'
import RewardCoupon from './fragments/reward-coupon'
import ShippingMethods from './fragments/shipping-methods'
import Cookie from 'js-cookie'
import {testPhone, testZip} from '../../validator'
import { getCountryAppMessage } from '../../../../../api'
import {Iconfont} from "../../../../components/icon/iconfont";
import {unitPrice} from "../../../../../utils/product";
import BuyBtn from "../../../details/module/buy-btn";
import QuickBuyProduct from "./fragments/quick-buy-product";

const ArrowDown = () => <Iconfont className={classes.Sword}>&#xe7c7;</Iconfont>;
const ArrowUp = () => <Iconfont className={classes.Sword}>&#xe63b;</Iconfont>;
const Checkout = props => {
    useStyles(classes)
    const history = useHistory()
    const store = useStore()
    const dispatch = useDispatch()
    const checkRef = useRef()
    const pageCart = useSelector(state => state.pageCart)
    const global = useSelector(state => state.global)
    const addressFunRef = useRef()
    const { cart, checkout, checkoutIniting, checkoutRefreshing, coupons, addresses, checkoutEmpty, cardList } = pageCart
    const [refreshing, setRefreshing] = useState(false)
    const query = useQuery()
    const {quickBuy=false,hidenPlaceOrder=false,selectedProduct,selectedVariant}=props
    const [hiddenComponent,setHiddenComponent]=useState(quickBuy&&selectedVariant==null)
    const {
        selectPayMethodHandle,
        selectShippingMethodHandle,
        selectShippingInsuranceHandle,
        selectCouponHandle,
        setAddressHandle,
        setDefaultAddressHandle,
        applyPointsHandle,
        applyCashHandle,
        applyCouponCodeHandle,
        klarnas
    } = useCheckout()

    const isLogin = useLogin()
    const payMethodRef = useRef()
    const Intl = useIntl()

    const [initialError, setInitialError] = useState(query?.errMsg)
    const [showCoupon, setShowCoupon] = useState(false)
    const [showAddressBook, setShowAddressBook] = useState(false)
    const [addressEditor, setAddressEditor] = useState({})
    const [showStayAlert, setShowStayAlert] = useState(false)
    const [showCouponTip, setShowCouponTip] = useState(true)
    const [selectedCard, setSelectedCard] = useState(null)
    const [privacyMsg, setPrivacyMsg] = useState(null)

    const currentCountry = checkout?.shippingDetail?.country?.value || cart?.country || global?.country

    useEffect(() => {

        try {
            if (window.GeekoSensors) {
                // window.GeekoSensors.Quick('autoTrackSinglePage', { 
                //     page_title: '下单页'
                // })
                window.pageTitle = '下单页'
                window.currentPage = 'checkout'
            }
        } catch (error) {

        }


        // const tempId = Cache.get('temp-order')
        // Cache.remove('temp-order')
        // if (tempId) {
        //     history.replace(`/checkout/${tempId}`)
        // }

        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (!checkout) {
                dispatch(action_cart_checkout_get(false))
            }
            try {
                if(window.pptag){
                    window.pptag.send('page_view', { page_type: 'CHECKOUT' })
                }
            } catch (error) {
                
            }
        }

        if (checkout && !checkout.shippingDetail) {
            addAddressHandle()
        }

        if (query.selectPayment) {
            payMethodRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else {
            window.scrollTo({
                top: 0,
            })
        }

        if (checkout) {
            SensorsTrack('fill_address', { is_fill: !!checkout?.shippingDetail })
            try {
                const rtbhEvents = window.rtbhEvents || []
                rtbhEvents.push( { eventType: 'startorder' },{ eventType: 'uid', id: global.user?.id || Cookie.get('clientId') });
            } catch (error) {
                
            }
        }

        if (cart) {
            SensorsTrack('Checkout', { is_success: true, product_qty: cart?.selectedProductCount, item_amount: Number(cart.summary?.usdItemTotal?.amount) || 0, pay_amount: Number(cart.summary?.usdSubTotal?.amount) || 0 })
        }

        if(initialError && initialError !== 'undefined' && initialError !== 'null'){
            handleError({message: initialError})
            setInitialError(null)
        }


    }, [])

    useEffect(async () => {
        if(!privacyMsg){
            const res = await getCountryAppMessage("M1840")
            if(res?.code == 200){
                // privacyMsg.current = res?.result || {}
                setPrivacyMsg(res?.result || {})
            }
        }
    }, [])

    useEffect(() => {
        if (checkoutEmpty) {
            history.replace('/cart')
        }
    }, [checkoutEmpty])

    addressFunRef.current = () => {
        addAddressHandle(checkout?.shippingDetail, true)
    }


    const handleError = state => {
        if (state.type === 'no_shipping') {
            //open shipping
            addAddressHandle()
        }else if(state.type === 'validate_shipping'){
            addressFunRef.current(checkout?.shippingDetail, true)
        } else if (state.type === 'no_paymethod') {
            //no paymethod
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: <FormattedMessage id="select_pay_method" defaultMessage="Please select a pay method!" />,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                            payMethodRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                        }
                    }
                }
            })
        } else if (state.type === 'go_unpaid') {
            // Cache.remove('temp-order')
            //go upaid

            // if (isLogin) {
            //     history.replace(`/checkout/${state.orderId}?errMsg=${state.message || ''}`)
            // } else {
                if(state.message){
                    dispatch({
                        type: TOOGLE_UI_ALERT,
                        payload: {
                            show: true,
                            options: {
                                content: state.message,
                                onConfirm: () => {
                                    dispatch({ type: TOOGLE_UI_ALERT, options: null })
                                }
                            }
                        }
                    })
                }
                
            // }

        } else if (state.type === 'force_refresh') {
            //refresh
            if (state.message) {
                dispatch({
                    type: TOOGLE_UI_ALERT,
                    payload: {
                        show: true,
                        options: {
                            content: state.message,
                            onConfirm: () => {
                                dispatch({ type: TOOGLE_UI_ALERT, options: null })
                                dispatch(action_cart_checkout_get())
                            }
                        }
                    }
                })
            }

        } else if (state.type === 'url_force_refresh') {
            if (state.message) {
                dispatch({
                    type: TOOGLE_UI_ALERT,
                    payload: {
                        show: true,
                        options: {
                            content: state.message,
                            onConfirm: () => {
                                window.location.reload()
                            }
                        }
                    }
                })
            } else {
                window.location.reload()
            }
        } else if (state.message) {
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: state.message,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        }
    }

    useEffect(async () => {
        if (checkout) {
            if (checkout.warnMsg) {
                handleError({
                    message: checkout.warnMsg
                })
            }
            dispatch(action_fetch_coupons())

            if(checkout.shippingDetail){
                Cache.set('shippingDetail', checkout.shippingDetail, 365*24*60*60)
            }

            try {
                const creditMethod = checkout.payMethodList?.find(p => p.id === '88' || p.id === '91' || p.id === '101' || p.id === '109')
                if (creditMethod) {
                    const cardList = await dispatch(action_fetch_card_list(Paymethods.getRelatedPayMethods(creditMethod.id)))
                    if (cardList?.length > 0) {
                        setSelectedCard(cardList.find(c => c.isSelected))
                    }else{
                        setSelectedCard(null)
                    }
                }else{
                    setSelectedCard(null)
                }
            } catch (error) {

            }

        }
    }, [checkout])

    const selectPayMethod = async payMethod => {
        const c = await selectPayMethodHandle(payMethod)

        if (payMethod === '1' && global.currency !== c.currency) {
            handleError({
                message: c.changedCurrencyMsg,
                type: 'url_force_refresh'
            })
        } else if (c.changedCurrencyMsg) {
            handleError({
                message: c.changedCurrencyMsg,
            })
        }
    }

    const __selectAddressHandle = useCallback(async values => {
        setRefreshing(true)
        await setDefaultAddressHandle({
            shippingDetailId: values?.id,
            isForce: true
        })
        await dispatch(action_fetch_addresses())
        setShowAddressBook(false)
        setRefreshing(false)
    }, [])

    const selectAddressHandle = async values => {

        const shouldValidate = checkout.parcels?.length > 0 && !checkout.parcels?.some(p => p.shipsFrom === values.country) && (checkout.parcels?.length > 1 || checkout.parcels?.[0].shipsFrom?.toLowerCase() !== 'overseas')


        if (shouldValidate) {
            dispatch({
                type: TOOGLE_UI_CONFIRM,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            __selectAddressHandle(values)
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        },
                        onCancel: () => {
                            dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        },
                        content: <FormattedMessage id="confirm_change_address" defaultMessage="Some items shipped from US stores will not be available for checkout, are you sure you want to switch addresses?" />
                    }
                }
            })
        } else {
            __selectAddressHandle(values)
        }

    }

    const openAddressBookHandle = async address => {

        SensorsTrack('PlaceOrderAction', { action: 'ClickAddress' })

        if (checkout?.shippingDetail) {
            if (isLogin) {
                if (!addresses) {
                    dispatch(action_fetch_addresses())
                }
                setShowAddressBook(true)
            } else {
                addAddressHandle(address)
            }

        } else {
            addAddressHandle(null)
        }
    }


    const addAddressHandle = async (addr, shouldValidate) => {
        setAddressEditor({ address: addr, show: true, country: currentCountry, shouldValidate })
        try {
            if (window.GeekoSensors) {
                SensorsTrack('address_edit', {
                    edit_type: addr?.id ? 'Edit Address' : 'Add Address',
                    address_country: currentCountry
                })
            }
        } catch (e) { }
    }

    const _onSubmitAddress = async values => {
        setRefreshing(true)
        const response = await setAddressHandle({ ...values, isForce: true })

        SensorsTrack('address_edit', {
            edit_type: values?.id ? 'Edit Address' : 'Add Address',
            is_success: response?.code === 200,
            address_country: values?.country,
            address_detail: `${values?.state}_${values.city}`,
        })

        setRefreshing(false)

        if(response?.code === 200){
            setShowAddressBook(false)
            setAddressEditor({
                address: null,
                show: false
            })
            dispatch(action_fetch_addresses())
            if (values?.email) {
                Cache.set('customerEmail', values?.email, 365 * 24 * 60 * 60)
            }
        }

        return response
    }

    const onSubmitAddress = async values => {
        // Overseas
        const shouldValidate = checkout.parcels?.length > 0 && !checkout.parcels?.some(p => p.shipsFrom === values.country) && (checkout.parcels?.length > 1 || checkout.parcels?.[0].shipsFrom?.toLowerCase() !== 'overseas')

        if (shouldValidate) {
            return new Promise(resolve => {
                dispatch({
                    type: 'TOOGLE_UI_CONFIRM',
                    payload: {
                        show: true,
                        options: {
                            onConfirm: async () => {
                                const response = await _onSubmitAddress(values)
                                dispatch({ type: 'TOOGLE_UI_CONFIRM', payload: null })
                                resolve(response)
                            },
                            onCancel: () => {
                                dispatch({ type: 'TOOGLE_UI_CONFIRM', payload: null })
                                resolve(true)
                            },
                            content: <FormattedMessage id="confirm_change_address" defaultMessage="Some items shipped from US stores will not be available for checkout, are you sure you want to switch addresses?" />
                        }
                    }
                })
            })
        } else {
            return _onSubmitAddress(values)
        }


    }

    const onCouponCode = async code => {
        const response = await applyCouponCodeHandle(code)
        if (response?.code !== 200) {
            handleError({
                message: response?.result
            })
        } else {
            setShowCoupon(false)
        }
    }

    // const mostPreferredCoupon = {
    //     name: '45% off',
    //     saved: {
    //         amount: '107.10',
    //         unit: '$',
    //         currency: 'USD'
    //     }
    // }

    const multiPack = checkout?.parcels?.length > 1

    checkRef.current = () => {
        const shippingDetail = checkout?.shippingDetail
        if(!testZip(shippingDetail.zipCode ,shippingDetail.country?.value) || !testPhone(shippingDetail.phoneNumber, shippingDetail.country?.value)){
            handleError({ type: 'validate_shipping' })
            return false
        }
        return true
    }

    const checkAddressHandle = () => {
        return checkRef.current()
    }
    // 控制展开/折叠
    const [paymentExpanded, setPaymentExpanded] = useState(false);
    // 点击箭头时切换展开状态
    const handlePaymentToggle = () => {
        setPaymentExpanded(!paymentExpanded);
    };
    // 控制展开/折叠
    const [orderSummaryExpanded, setOrderSummaryExpanded] = useState(false);
    const handleOrderSummaryToggle = () => {
        setOrderSummaryExpanded(!orderSummaryExpanded);
    };

    return <NormalPage onBack={() => {
        SensorsTrack('PlaceOrderAction', { action: 'ClickBack' })
        const cachedType = Cache.get('retention_type')

        if (!checkoutEmpty && checkout?.retentionPromptWin && cachedType !== checkout.retentionPromptWin.type) {
            setShowStayAlert(true)
        } else {
            if(query?.status === 'CANCELLED'){
                history.go(-3)
            }else if(document.referrer?.indexOf(global.config?.domain) < 1) {
                history.go(-4)
            }else{
                history.goBack()
            }
        }
    }} title={
        <FormattedMessage id="order_confirmation" defaultMessage="Order Confirmation" />
    } privacyMsg={privacyMsg} privacyPadding={true} hideHeader={quickBuy} hideSecure={quickBuy}>
        {
            checkoutIniting && <LoadingPage />
        }
        {
            !checkoutIniting && checkout && <>
                {
                    showCouponTip && checkout.mostPreferredCoupon && !checkout.coupon && <CouponTip onClick={e => {
                        SensorsTrack('PlaceOrderAction', { action: 'ClickCouponTip' })
                        setShowCoupon(true)
                    }} onClose={() => setShowCouponTip(false)} mostPreferredCoupon={checkout.mostPreferredCoupon} />
                }
                <NBoxes className={`${quickBuy?'':classes.Box}`}>
                    {
                        !quickBuy&&<Box>
                            <BaseBox hdClassName={classes.Height_54} title={(
                                <div className={classes.Order_summary_div} onClick={handleOrderSummaryToggle}>
                                    <FormattedMessage id="order_summary" defaultMessage="Order summary"/>
                                    <div style={{display: 'flex'}}>
                                        <div className={classes.OrderSummaryText}>
                                            <span>{unitPrice(checkout.orderSummary?.orderTotal)}</span></div>
                                        <div>{orderSummaryExpanded ? <ArrowUp/> : <ArrowDown/>}</div>
                                    </div>
                                </div>
                            )}>
                                {
                                    orderSummaryExpanded && !multiPack && <Box>
                                        <Groups multiPack={multiPack} soldoutProducts={checkout.soldoutProducts}
                                                selectShippingMethodHandle={selectShippingMethodHandle}
                                                selectShippingInsuranceHandle={selectShippingInsuranceHandle}
                                                parcels={checkout?.parcels}/>
                                    </Box>
                                }

                                {
                                    orderSummaryExpanded && <Box>
                                        <OrderSummary orderSummary={checkout.orderSummary}/>
                                    </Box>
                                }
                            </BaseBox>
                        </Box>
                    }


                    <Box>
                        {
                            checkout?.shippingDetail ? <div className={classes.AddressContainer}>
                                <AddressSelector showIcon onSelect={openAddressBookHandle} address={checkout?.shippingDetail} />
                            </div> : <EmptyTitle onClick={addAddressHandle} title={<FormattedMessage id="shipping_address" defaultMessage="Shipping Address" />} />
                        }
                    </Box>
                    {
                        quickBuy&&<Box className={classes.QuickBuyProductBox}>
                        <QuickBuyProduct selectedProduct={selectedProduct} selectedVariant={selectedVariant} setHiddenComponent={setHiddenComponent}/>
                        </Box>
                    }

                    {
                        !multiPack && checkout?.parcels?.[0] && <Box>
                            <ShippingMethods
                                shippingInsuranceMsg={checkout.parcels[0]?.shippingInsuranceMsg}
                                shippingMethods={checkout.parcels[0]?.shippingMethods}
                                preOrderShippingMethods={checkout.parcels[0]?.preOrderShippingMethods}
                                useShippingInsurance={checkout.parcels[0]?.useShippingInsurance}
                                expectedShippingInsurance={checkout.parcels[0]?.expectedShippingInsurance}
                                onShippingMethod={shippingMethod => selectShippingMethodHandle({
                                    shippingMethodId: shippingMethod?.id,
                                    shipsFrom: checkout.parcels[0]?.shipsFrom
                                })}
                                onInsurance={value => selectShippingInsuranceHandle({
                                    useShippingInsurance: value,
                                    shipsFrom: checkout.parcels[0]?.shipsFrom
                                })}
                                isOversea={checkout?.parcels?.[0]?.shipsFrom == "Overseas"}
                                preOrderItemCount={checkout?.parcels?.[0]?.preOrderItemCount}
                                itemCount={checkout?.parcels?.[0]?.itemCount}
                                />
                        </Box>
                    }

                </NBoxes>

                {
                    multiPack && <div className={classes.Box}>
                        <Groups
                            multiPack={multiPack}
                            soldoutProducts={checkout.soldoutProducts}
                            selectShippingMethodHandle={selectShippingMethodHandle}
                            selectShippingInsuranceHandle={selectShippingInsuranceHandle}
                            parcels={checkout?.parcels}
                            />
                    </div>
                }

                {!hiddenComponent&&<NBoxes className={`${quickBuy?classes.Box2:classes.Box}`}>

                    <Box innerRef={payMethodRef}>
                        <BaseBox title={(
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    width: '100%',
                                }}onClick={handlePaymentToggle}>
                                <FormattedMessage id="payment_method" defaultMessage="Payment Method" />
                                {paymentExpanded ? <ArrowUp /> : <ArrowDown />}
                            </div>
                        )}>
                            <PaymentMethods
                                onError={handleError}
                                selectedCard={selectedCard}
                                klarnas={klarnas}
                                className={classes.PaymentMethods}
                                orderTotal={checkout.orderSummary?.orderTotal}
                                selectPayMethodHandle={selectPayMethod}
                                selectedPayMethod={checkout.payMethod} 
                                payMethodList={checkout?.payMethodList}  
                                ignoreViewMore
                                check={checkAddressHandle}
                                expanded={paymentExpanded}
                            />
                        </BaseBox>
                    </Box>

                    <Box className={classes.Tools}>
                        <CouponTool onClick={e => {
                            SensorsTrack('PlaceOrderAction', { action: 'ClickCoupon' })
                            setShowCoupon(true)
                        }}
                            canUseCouponCount={checkout.canUseCouponCount}
                            availableCouponCount={checkout.availableCouponCount}
                            coupon={checkout.coupon}
                            mostPreferredCoupon={checkout.mostPreferredCoupon}
                        />

                        {
                            checkout.expectedCashDiscount?.amount > '0' && <WalletTool
                                cashDescription={checkout.cashDescription}
                                usedCash={checkout.usedCash}
                                cash={checkout.cash}
                                expectedCashDiscount={checkout.expectedCashDiscount}
                                applyCashHandle={applyCashHandle} />
                        }

                        {
                            checkout.expectedPoints > 0 && <PointsTool
                                openPointUse={checkout.openPointUse}
                                pointsDescription={checkout.pointsDescription}
                                canUsePoints={checkout.canUsePoints}
                                expectedPoints={checkout.expectedPoints}
                                expectedPointDiscount={checkout.expectedPointDiscount}
                                pointsDiscount={checkout.orderSummary?.pointDiscount}
                                points={checkout.points}
                                applyPointsHandle={applyPointsHandle}
                            />
                        }
                    </Box>


                    {
                        checkout.rewardCoupon&&!quickBuy && <Box>
                            <RewardCoupon rewardCoupon={checkout.rewardCoupon} />
                        </Box>
                    }
                </NBoxes>}

                {!hidenPlaceOrder&&<PlaceorderFooter
                    klarnas={klarnas}
                    payMethod={checkout.payMethodList?.find?.(p => p.id === checkout.payMethod)}
                    orderTotal={checkout.orderSummary?.orderTotal}
                    saved={checkout.orderSummary?.saved} 
                    payMethodTaxAmount={checkout.orderSummary?.payMethodTaxAmount} 
                    shippingDetail={checkout.shippingDetail}
                    onError={handleError}
                    onCouponHandle={() => setShowCoupon(true)}
                    showStayAlert={showStayAlert}
                    setShowStayAlert={setShowStayAlert}
                    selectedCard={selectedCard} 
                    buttonPopups={checkout.buttonPopups}
                    orderSummary={checkout.orderSummary}
                    quickBuy={quickBuy}
                />}

                <AddressBook onSelect={selectAddressHandle} addresses={addresses} show={showAddressBook} onAddAddress={addAddressHandle} onClose={() => { setShowAddressBook(false) }} />
                <AddressEditor instantValidate={addressEditor?.shouldValidate} country={addressEditor?.country} address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />


                {
                    (checkoutRefreshing || refreshing) && <Loading />
                }


                <CouponSelector onCouponCode={onCouponCode} couponDiscount={checkout.orderSummary?.couponDiscount} selectedCoupon={checkout.coupon} onSelect={selectCouponHandle} show={showCoupon} onClose={() => setShowCoupon(false)} coupons={coupons} quickBuy={quickBuy} onClick={e=>{
                    Cache.remove("__progress_coupon_id")
                    history.push(getSensorsUrl('/cart/collect-products?type=1'));
                }}/>
            </>
        }


    </NormalPage>
}

Checkout.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_cart_checkout_get(true, headers))
}

export default Checkout